export enum CardStatus {
    UNKNOWN = 'unknown',
    IN_PLAY = 'in_play',
    IN_STACK = 'in_stack',
    FOLDED = 'folded',
    DISCARDED = 'discarded',
}
